<template>
  <div class="news-content">
    <div class="title-content">
      <div class="big-title">{{ $t("route.news") }}</div>
      <div class="small-title">Industry News</div>
    </div>
    <div class="news-select-content">
      <div
        class="news-item"
        @click="newsDetailClick(item)"
        :key="item.id"
        v-for="item in newsList"
      >
        <div class="news-item-time">
          <span class="time-day">{{ item.date[2] }}</span>
          <span class="time-year-month"
            >{{ item.date[0]
            }}<span v-if="$i18n.locale === 'zh'">{{ $t("news.year") }}</span
            >/{{ item.date[1]
            }}<span v-if="$i18n.locale === 'zh'">{{
              $t("news.month")
            }}</span></span
          >
        </div>
        <div class="news-item-text">{{ item.title }}</div>
        <div class="news-item-img">
          <img :src="item.thumbnails" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/axios/index.js";
export default {
  name: "news",
  props: {
    msg: String,
  },
  data() {
    return {
      params: {
        page: 1,
        pageSize: 100,
        orders: { sequence: "desc" },
        param: {
          lang: "zh_CN",
        },
      },
      newsList: [],
    };
  },
  methods: {
    newsDetailClick(data) {
      this.$router.push({
        name: "mobile-news-detail",
        params: data,
      });
    },
    getNewsPage() {
      const url = `/frontIndustryNews/${this.params.param.lang}`;
      http
        .get(url)
        .then((res) => {
          if (res.code === "00000") {
            res.data.forEach((item) => {
              let arr = item.releaseTime.split("-");
              item.date = [arr[0], arr[1], arr[2]];
            });
            this.newsList = res.data;
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  created() {
    if (this.$i18n.locale === "zh") {
      this.params.param.lang = "zh_CN";
    } else if (this.$i18n.locale === "en") {
      this.params.param.lang = "en";
    }
    this.getNewsPage();
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (newValue === "zh") {
        this.params.param.lang = "zh_CN";
      } else {
        this.params.param.lang = "en";
      }
      this.getNewsPage();
    },
  },
};
</script>
<style lang="less" scoped>
.news-content {
  box-sizing: border-box;
  overflow: scroll;
  .title-content {
    padding-top: 9.4rem;
    padding-bottom: 7.4rem;
    text-align: center;
    .big-title {
      font-size: 4.2rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #2b2b2b;
    }

    .small-title {
      font-size: 2.4rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #1ea5ff;
    }
  }
  .news-select-content {
    .news-item {
      display: flex;
      justify-content: space-between;
      // align-items: center;
      box-sizing: border-box;
      overflow: hidden;
      padding: 3rem 0 3rem 0;
      margin: 0 4rem;
      border-bottom: 1px solid #eeeeee;
      &:first-child {
        padding-top: unset;
      }
      &:last-child {
        border-bottom: unset;
      }

      .news-item-time {
        text-align: center;
        display: flex;
        flex-direction: column;
        color: #09a7f5;
        .time-day {
          white-space: nowrap;
          font-size: 10rem;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          line-height: 8rem;
        }
        .time-year-month {
          white-space: nowrap;
          font-size: 2rem;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
        }
      }
      .news-item-text {
        width: 31.2rem;
        font-size: 2.8rem;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2b2b2b;
      }
      .news-item-img {
        width: 17.6rem;
        height: 11.4rem;
        border-radius: 2rem;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
